// 19.1.3.1 Object.assign(target, source)
var $export = require('./_export');

$export($export.S + $export.F, 'Object', { assign: require('./_object-assign') });



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/es6.object.assign.js
 ** module id = 1012
 ** module chunks = 0
 **/